import { hexWithAlpha } from "../utils";

export default {
  default: {
    text: "#224858;",
    background: "#EFF5F7",
    gradient: "linear-gradient(134.02deg, #163F51 -8.22%, #1DB6F8 149.35%);",
    underline: "#CBE1EA"
  },
  jobList: {
    background: {
      active: " #224858;",
      pending: "#84A3B0;",
      expired: "#ABABAB;"
    },
    button: {
      active: "#346C84;",
      pending: "#5D727B;",
      expired: "#7A7A7A;"
    }
  },
  tokens: {
    background: "linear-gradient(180deg, #2897AF 0%, #1F8FB9 100%)",
    discountBackground:
      "linear-gradient(163.78deg, #224858 -10.01%, #1DB6F8 111.52%)",
    availableBackground: "#F4F4F4",
    mainText: "#fff",
    available: "#2897B0",
    text: "#276273"
  },
  paymentDeclined: {
    background: "#EFF5F7"
  },
  billingLocation: {
    background: "#EFF5F7",
    radioActive: "linear-gradient(160.5deg, #317693 3.81%, #23A2D9 86.92%)",
    radio: "#346C84",
    text: "#224858",
    selectedBackground: "#CBE1EA"
  },
  confirmButton: {
    background: "linear-gradient(153.32deg, #163F51 -8.22%, #1DB6F8 149.35%)",
    redBackground:
      "linear-gradient(155.74deg, #292732 -95.37%, #9F2226 150.63%)",
    grayBackground:
      "linear-gradient(0deg, #658A9A, #658A9A), linear-gradient(136.81deg, #163F51 -8.22%, #1DB6F8 149.35%)",
    text: "#fff",

    greenBackground:
      "linear-gradient(155.26deg, #6CF5B7 -8.22%, #2FA3A3 149.35%)",
    greenText: "#224858",

    whiteBackground: "#EFF5F7",
    whiteText: "#276273",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)"
  },
  candidateView: {
    background: "#EFF5F7",
    text: "#224858",
    scoreLoaderBackground:
      "linear-gradient(0deg, #E1E8FC, #E1E8FC), linear-gradient(191.9deg, #1DB6F8 -41.35%, #1DF881 101.56%, #2897AF 101.56%)",
    scoreBoxShadow: "0px 0px 6px rgba(0, 0, 0, 0.15)",
    scoreBackground:
      "linear-gradient(0deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.35)), linear-gradient(191.9deg, #1DB6F8 -41.35%, #1DF881 101.56%, #2897AF 101.56%)",
    resumeBorder: "5px solid #84A3B0"
  },
  radioForm: {
    defaultBackground: "#EFF5F7",
    defaultSelectedBackground: "#CBE1EA"
  },
  calendar: {
    background: "#CBE1EA",
    headerText: "white",
    headerBackground: "#224858",
    weekendsBackground: "#83B0C4",
    text: "#224858",
    activeText: "#fff",
    activeBackground: "#224858"
  },
  calendarRedesigned: {
    background: "#fff",
    headerText: "#fff",
    headerBackground: "#FB7672",
    weekendsBackground: "rgba(246,132,0,0.6)",
    text: "#000",
    activeText: "#fff",
    activeBackground: "#FB7672"
  },
  addCard: {
    background: "#F4F4F4"
  },
  addOfficeLocation: {
    background: "#EFF5F7",
    text: "#224858",
    placeholder: "#63A5C0",
    inputBorder: "#C6DEE9",
    separator: "#CBE1EA"
  },
  popup: {
    background: "rgba(0, 0, 0, 0.7)"
  },
  jobPost: {
    background: "#FDFDFD",
    underline: "#C4D9E3",
    text: "#224858",
    applied: '#63A5C0',
  },

  horizontalPicker: {
    background: "#C6DEE9",
    itemBackground:
      "linear-gradient(153.68deg, #224858 -18.17%, #1DB6F8 117.08%)",
    itemColor: "#fff"
  },

  chooseBioRadio: {
    activeBackground: "#FB7672",
  }
};
